import React, {Component}   from "react";
import {Dropdown}           from "react-native-material-dropdown";
import styles               from "../styles/Styles";

export default class RNMDropdown extends Component {
    render() {
        return (
            <Dropdown containerStyle={styles.dropdownContainer} data={this.props.data} dropdownPosition={0} inputContainerStyle={styles.dropdownInput} 
                itemTextStyle={styles.dropdownItemText} label={this.props.label} onChangeText={this.props.onChangeText} 
                pickerStyle={this.props.pickerStyle} style={styles.dropdown} value={this.props.value} />
        );
    }
}